import { useRef } from 'react';
import { FormApi } from '@douyinfe/semi-ui/lib/es/form';
import { useEventBus, useStateRealtime } from '@byted/hooks';
import {
  Toast,
  Typography,
  Form,
  DropdownDivider,
  Banner,
} from '@douyinfe/semi-ui';
import { SylApi } from '@syllepsis/adapter';
import _ from 'lodash';
import { EditorV2 } from '../EditorV2';
import { TitleFormItem } from './TitleFormItem';
import { FormData } from '@/components/creat-work-order/utils';
import CreateOrder from '@/components/creat-work-order';

import {
  CreatePostRequest,
  CreatePostResponseData,
} from '@/typings/open.platform.forum_bff/namespaces/forumpost';
import useBiz from '@/context/useBiz';
import { useScope } from '@/hooks/useScope';
import { PostType } from '@/typings/fe';

type Props = {
  submitPost: (req: CreatePostRequest) => Promise<CreatePostResponseData>;
};
export const QuestionPost: React.FC<Props> = ({ submitPost }) => {
  const { Text } = Typography;
  const [, setMeta, getMeta] = useStateRealtime({});
  const formRef = useRef<FormApi<{
    Title: string;
  }> | null>(null);
  const editorRef = useRef<SylApi | null>(null);
  const scope = useScope();
  const biz = useBiz(state => state.biz);

  useEventBus('POST_SUBMIT', async (type: PostType) => {
    if (type !== 'question') {
      return;
    }

    const values = await formRef.current?.validate();
    if (!values) {
      return;
    }

    const newValues = _.pickBy(values, _.identity);

    const html = editorRef.current?.getHTML();
    if (!html) {
      Toast.error('正文内容不能为空');
      return;
    }
    submitPost({
      Scope: scope,
      Biz: biz,
      Html: html,
      Title: values.Title,
      Meta: {
        ...getMeta(),
        ...newValues,
      },
      Uid: '',
      Type: 'question',
    });
  });

  const onPostSubmit = (selectedItems: string[], _list: Array<FormData[]>) => {
    if (selectedItems.length < 3) {
      return;
    }
    setMeta(prev => ({
      ...prev,
      发帖板块: selectedItems[0],
      问题类型: selectedItems[1],
      问题模块: selectedItems[2],
    }));
  };
  return (
    <div className="bg-white px-8 py-6 mt-4 rounded-xl ">
      <Banner
        className="mb-10"
        closeIcon={null}
        fullMode={false}
        type="info"
        description={
          <div>
            问题发布后，将于 7
            个工作日内得到平台官方回复，如果不希望公开发布问题，<br></br>
            你可以前往
            <Text
              link={{
                href: 'https://developer.open-douyin.com',
                target: '_blank',
              }}>
              抖开平台
            </Text>
            右下角咨询人工客服，或者提交
            <Text link={{ href: '/work-order-page' }}>技术工单</Text>
          </div>
        }
      />
      <Typography.Title heading={6}>基础信息</Typography.Title>
      <Form
        autoScrollToError={{
          skipOverflowHiddenElements: true,
          behavior: 'smooth',
        }}
        getFormApi={formApi => {
          formRef.current = formApi;
        }}>
        <TitleFormItem />

        <CreateOrder onPostSubmit={onPostSubmit} />
      </Form>
      <DropdownDivider className="my-8" />
      <Typography.Title heading={6}>文章正文</Typography.Title>
      <EditorV2
        getEditorInstance={edtior => (editorRef.current = edtior)}
        className={'mt-6'}
      />
    </div>
  );
};
